const RETURN_PATH_KEY = 'jlm:return-path'

/**
 * Discord OAuth takes over the whole page on web and desktop, so the route the
 * user started from has to be remembered across the round trip. The original
 * always dropped users back on "/" with a hard
 * `window.location.href = window.location.origin + "/"`, losing their place.
 */
export function saveReturnPath(path: string): void {
  try {
    localStorage.setItem(RETURN_PATH_KEY, path)
  } catch {
    /* storage unavailable */
  }
}

export function takeReturnPath(): string {
  try {
    const path = localStorage.getItem(RETURN_PATH_KEY)
    localStorage.removeItem(RETURN_PATH_KEY)
    // Only ever return an in-app path; never an absolute URL from storage.
    return path && path.startsWith('/') && !path.startsWith('//') ? path : '/'
  } catch {
    return '/'
  }
}
